
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/styles.css";
import logo from "../img/NYATWENDE LOGO.png";
import { FaBars, FaTimes, FaUserCircle, FaSignOutAlt, FaPen } from "react-icons/fa";
import { GoogleLogin } from "@react-oauth/google";
import { API_BASE } from "../api";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [user, setUser] = useState(null);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
    setShowUserMenu(false);
  }, [location]);

  // Restore session from localStorage
  useEffect(() => {
    const token = localStorage.getItem("nyatwende_token");
    const saved = localStorage.getItem("nyatwende_user");
    if (token && saved) {
      try { setUser(JSON.parse(saved)); } catch { }
    }
  }, []);

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const res = await fetch(`${API_BASE}/api/auth/google`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ credential: credentialResponse.credential }),
      });
      const data = await res.json();
      if (!res.ok) {
        console.error("Auth response:", res.status, data);
        alert("Login failed: " + (data.error || res.status));
        return;
      }
      localStorage.setItem("nyatwende_token", data.token);
      localStorage.setItem("nyatwende_user", JSON.stringify(data.user));
      setUser(data.user);
      window.dispatchEvent(new Event("nyatwende_auth_change"));
    } catch (err) {
      console.error("Login error:", err);
      alert("Login failed: " + err.message);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("nyatwende_token");
    localStorage.removeItem("nyatwende_user");
    setUser(null);
    setShowUserMenu(false);
    window.dispatchEvent(new Event("nyatwende_auth_change"));
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
      <div className="nav-container">
        <Link to="/" className="logo" onClick={closeMenu}>
          <img src={logo} alt="Nyatwende Logo" />
        </Link>

        {/* Auth - always visible, sits between logo and hamburger on mobile */}
        <div className="nav-auth">
          {user ? (
            <div className="nav-user-wrap">
              <button className="nav-user-btn" onClick={() => setShowUserMenu(!showUserMenu)}>
                {user.picture ? (
                  <img src={user.picture} alt={user.name} className="nav-user-avatar" referrerPolicy="no-referrer" />
                ) : (
                  <FaUserCircle className="nav-user-icon" />
                )}
                <span className="nav-user-name">{user.name?.split(" ")[0]}</span>
              </button>
              {showUserMenu && (
                <div className="nav-user-dropdown">
                  <div className="nav-user-info">
                    <strong>{user.name}</strong>
                    <span>{user.email}</span>
                    {user.role === "admin" && <span className="nav-admin-badge">Admin</span>}
                  </div>
                  <Link to="/write" className="nav-dropdown-item" onClick={() => { setShowUserMenu(false); closeMenu(); }}>
                    <FaPen /> Write a Blog
                  </Link>
                  {user.role === "admin" && (
                    <Link to="/admin" className="nav-dropdown-item" onClick={() => { setShowUserMenu(false); closeMenu(); }}>
                      <FaUserCircle /> Admin Panel
                    </Link>
                  )}
                  <button className="nav-dropdown-item logout" onClick={handleLogout}>
                    <FaSignOutAlt /> Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="nav-google-login">
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => console.log("Login Failed")}
                size="medium"
                shape="pill"
                text="signin"
                theme="outline"
              />
            </div>
          )}
        </div>

        <div className="hamburger" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={isOpen ? "nav-links active" : "nav-links"}>
          <li>
            <Link to="/" className={location.pathname === "/" ? "nav-active" : ""} onClick={closeMenu}>Home</Link>
          </li>
          <li>
            <Link to="/about" className={location.pathname === "/about" ? "nav-active" : ""} onClick={closeMenu}>About Us</Link>
          </li>
          <li>
            <Link to="/services" className={location.pathname === "/services" ? "nav-active" : ""} onClick={closeMenu}>Services</Link>
          </li>
          <li>
            <Link to="/destinations" className={location.pathname === "/destinations" ? "nav-active" : ""} onClick={closeMenu}>Destinations</Link>
          </li>
          <li>
            <Link to="/tours" className={location.pathname === "/tours" ? "nav-active" : ""} onClick={closeMenu}>Tours & Safaris</Link>
          </li>
          <li>
            <Link to="/handpicked-stays" className={location.pathname === "/handpicked-stays" ? "nav-active" : ""} onClick={closeMenu}>Stays</Link>
          </li>
          <li>
            <Link to="/contact" className={location.pathname === "/contact" || location.pathname === "/design-your-trip" ? "nav-active" : ""} onClick={closeMenu}>Design Your Trip</Link>
          </li>
          <li>
            <Link to="/blogs" className={location.pathname.startsWith("/blog") ? "nav-active" : ""} onClick={closeMenu}>Blogs</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;